export const GET_MEDICINE_CATEGORIES = "GET_MEDICINE_CATEGORIES";
export const GET_MEDICINE_CATEGORIES_SUCCESS = "GET_MEDICINE_CATEGORIES_SUCCESS";
export const GET_MEDICINE_CATEGORIES_FAIL = "GET_MEDICINE_CATEGORIES_FAIL";

export const CREATE_MEDICINE_CATEGORY = "CREATE_MEDICINE_CATEGORY";
export const CREATE_MEDICINE_CATEGORY_SUCCESS = "CREATE_MEDICINE_CATEGORY_SUCCESS";
export const CREATE_MEDICINE_CATEGORY_FAIL = "CREATE_MEDICINE_CATEGORY_FAIL";

export const UPDATE_PART_MED_DATA = "UPDATE_PART_MED_DATA";
export const UPDATE_PART_MED_DATA_SUCCESS = "UPDATE_PART_MED_DATA_SUCCESS";
export const UPDATE_PART_MED_DATA_FAIL = "UPDATE_PART_MED_DATA_FAIL";

export const GET_ADDED_MEDICINE = "GET_ADDED_MEDICINE";
export const GET_ADDED_MEDICINE_SUCCESS = "GET_ADDED_MEDICINE_SUCCESS";
export const GET_ADDED_MEDICINE_FAIL = "GET_ADDED_MEDICINE_FAIL";

export const ADD_MEDICINE_TO_CATEGORY = "ADD_MEDICINE_TO_CATEGORY";
export const ADD_MEDICINE_TO_CATEGORY_SUCCESS = "ADD_MEDICINE_TO_CATEGORY_SUCCESS";
export const ADD_MEDICINE_TO_CATEGORY_FAIL = "ADD_MEDICINE_TO_CATEGORY_FAIL";

export const UPDATE_MEDICINE_OF_CATEGORY = "UPDATE_MEDICINE_OF_CATEGORY";
export const UPDATE_MEDICINE_OF_CATEGORY_SUCCESS = "UPDATE_MEDICINE_OF_CATEGORY_SUCCESS";
export const UPDATE_MEDICINE_OF_CATEGORY_FAIL = "UPDATE_MEDICINE_OF_CATEGORY_FAIL";

export const DELETE_MEDICINE_OF_CATEGORY = "DELETE_MEDICINE_OF_CATEGORY";
export const DELETE_MEDICINE_OF_CATEGORY_SUCCESS = "DELETE_MEDICINE_OF_CATEGORY_SUCCESS";
export const DELETE_MEDICINE_OF_CATEGORY_FAIL = "DELETE_MEDICINE_OF_CATEGORY_FAIL";

export const GET_MEDICINE_DETAILS = "GET_MEDICINE_DETAILS";
export const GET_MEDICINE_DETAILS_SUCCESS = "GET_MEDICINE_DETAILS_SUCCESS";
export const GET_MEDICINE_DETAILS_FAIL = "GET_MEDICINE_DETAILS_FAIL";

export const GET_MED_DROP_LIST = "GET_MED_DROP_LIST";
export const GET_MED_DROP_LIST_SUCCESS = "GET_MED_DROP_LIST_SUCCESS";
export const GET_MED_DROP_LIST_FAIL = "GET_MED_DROP_LIST_FAIL";

export const GET_TASK_MED_DETAILS = "GET_TASK_MED_DETAILS";
export const GET_TASK_MED_DETAILS_SUCCESS = "GET_TASK_MED_DETAILS_SUCCESS";
export const GET_TASK_MED_DETAILS_FAIL = "GET_TASK_MED_DETAILS_FAIL";

export const GET_PART_MED_DETAILS = "GET_PART_MED_DETAILS";
export const GET_PART_MED_DETAILS_SUCCESS = "GET_PART_MED_DETAILS_SUCCESS";
export const GET_PART_MED_DETAILS_FAIL = "GET_PART_MED_DETAILS_FAIL";

export const SAVE_PART_MED_DETAILS = "SAVE_PART_MED_DETAILS";
export const SAVE_PART_MED_DETAILS_SUCCESS = "SAVE_PART_MED_DETAILS_SUCCESS";
export const SAVE_PART_MED_DETAILS_FAIL = "SAVE_PART_MED_DETAILS_FAIL";

export const DELETE_MEDICINE_DOC = "DELETE_MEDICINE_DOC";
export const DELETE_MEDICINE_DOC_SUCCESS = "DELETE_MEDICINE_DOC_SUCCESS";
export const DELETE_MEDICINE_DOC_FAIL = "DELETE_MEDICINE_DOC_FAIL";

export const REMOVE_MED_PART_PROFILE = "REMOVE_MED_PART_PROFILE";
export const REMOVE_MED_PART_PROFILE_SUCCESS = "REMOVE_MED_PART_PROFILE_SUCCESS";
export const REMOVE_MED_PART_PROFILE_FAIL = "REMOVE_MED_PART_PROFILE_FAIL";

export const ADD_MED_LIST_PARTICIAPNT = "ADD_MED_LIST_PARTICIAPNT";
export const ADD_MED_LIST_PARTICIAPNT_SUCCESS = "ADD_MED_LIST_PARTICIAPNT_SUCCESS";
export const ADD_MED_LIST_PARTICIAPNT_FAIL = "ADD_MED_LIST_PARTICIAPNT_FAIL";

export const UPDATE_PART_MED_LIST = "UPDATE_PART_MED_LIST";
export const UPDATE_PART_MED_LIST_SUCCESS = "UPDATE_PART_MED_LIST_SUCCESS";
export const UPDATE_PART_MED_LIST_FAIL = "UPDATE_PART_MED_LIST_FAIL";

export const GET_TASK_MED_REPORT = "GET_TASK_MED_REPORT";
export const GET_TASK_MED_REPORT_SUCCESS = "GET_TASK_MED_REPORT_SUCCESS";
export const GET_TASK_MED_REPORT_FAIL = "GET_TASK_MED_REPORT_FAIL";

export const GET_PARTICIPANT_MEDICATION_REPORT = "GET_PARTICIPANT_MEDICATION_REPORT";
export const GET_PARTICIPANT_MEDICATION_REPORT_SUCCESS = "GET_PARTICIPANT_MEDICATION_REPORT_SUCCESS";
export const GET_PARTICIPANT_MEDICATION_REPORT_FAIL = "GET_PARTICIPANT_MEDICATION_REPORT_FAIL";

export const GET_PART_MEDICINE_LOGS = "GET_PART_MEDICINE_LOGS";
export const GET_PART_MEDICINE_LOGS_SUCCESS = "GET_PART_MEDICINE_LOGS_SUCCESS";
export const GET_PART_MEDICINE_LOGS_FAIL = "GET_PART_MEDICINE_LOGS_FAIL";

export const GET_MEDICATION_LOG = "GET_MEDICATION_LOG";
export const GET_MEDICATION_LOG_SUCCESS = "GET_MEDICATION_LOG_SUCCESS";
export const GET_MEDICATION_LOG_FAIL = "GET_MEDICATION_LOG_FAIL";
